import { Stack, styled } from '@mui/material';

export const SubMenuHeaderActionContainer = styled(Stack)({
  alignItems: 'center',
  paddingTop: 16,
  paddingBottom: 15,
  paddingLeft: 24,
  paddingRight: 16,
});

SubMenuHeaderActionContainer.defaultProps = {
  ...SubMenuHeaderActionContainer.defaultProps,
  direction: 'row',
  spacing: 2,
};
